import { render, staticRenderFns } from "./spareRequirementsDetail.vue?vue&type=template&id=70696cec&scoped=true"
import script from "./spareRequirementsDetail.vue?vue&type=script&lang=js"
export * from "./spareRequirementsDetail.vue?vue&type=script&lang=js"
import style0 from "./spareRequirementsDetail.vue?vue&type=style&index=0&id=70696cec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70696cec",
  null
  
)

export default component.exports